"use strict";
import React from "react";
import vinSearch from "./vinSearch";
import RouterContext from "../contexts/routerContext";
import { getLogoutUrl } from './../util/helpers';
import { CLAIMS } from '../constants';
import Typeahead from './typeahead';

const initComponent = (flex = window.flex) => {
    const VinSearch = vinSearch(flex);

    class MainSubNav extends React.Component {
        static contextType = RouterContext;

        render() {
            const appContext = this.props.appContext;
            const topNav = this.props.topNav;
            const tempNav = appContext.nav || {};
            const tempNavs = tempNav.navs || [];
            const { Link } = this.context;

            const navs = tempNavs.map((nav, index) => {
                let isCurrentMenu = nav.id.toUpperCase() === topNav.toUpperCase()
                var subNavs = isCurrentMenu ?
                    (nav.subNavs.map((subNav, subNavIndex) => {
                        let isCurrentMenu = window.location.pathname.toUpperCase() === (subNav.link.toUpperCase());
                        return <li key={nav.id + "-" + subNavIndex}>
                            <Link to={subNav.link} onClick={this.props.toggleMobileNav} className={isCurrentMenu ? "active" : ""}>{subNav.summary}</Link>
                        </li>
                    })) : false;

                return (
                    <ul className="nav-list horizontal active" key={index}>
                        {subNavs}
                    </ul>
                );
            });
            return (<div className="container container-fluid">
                {navs}
            </div>);
        }
    }

    class NavTop extends React.PureComponent {
        static contextType = RouterContext;
        static defaultProps = {
            const: false
        };

        render() {
            const visible = this.props.visible || false;
            if (!visible) { return false; }
            const appContext = this.props.appContext;
            if (!appContext) { return false; }
            const { topNav, session, handleNavItemclick, handleSublinkClick } = this.props;

            const Claims = appContext.claims;
            const app = appContext.app;
            const Admin = app.kind;
            let claim1 = flex.claim("per.InventoryVehicleAdmin.CanAccessVinSearch", Claims);
            let claim2 = flex.claim("fea.InventoryVehicleAdmin.EnableVinQuickSearch", Claims);
            let claim = (claim1 && claim2) ? <VinSearch></VinSearch> : null;
            let result = Admin ? claim : null;
            const logoutUrl = getLogoutUrl(flex);

            const navClass = this.props.navClass || "xs-hidden";
            const tempNav = appContext.nav || {};
            const tempNavs = tempNav.navs || [];
            const { Link } = this.context;

            const helpUrl = appContext.app ? appContext.app.helpUrl : false;
            
            const navs = tempNavs.map((nav, index) => {
                let navItemClass = "nav-" + flex.replaceAll(nav.id, ".", "-").toLowerCase();
                let navItemActiveClass = (nav.id.toUpperCase() === topNav.toUpperCase() ? " active" : "");
                const hasSubNavsClass = nav.subNavs.length ? ' nav-has-subnav' : '';
                navItemClass = navItemClass + navItemActiveClass + hasSubNavsClass;
                var subNavs = !nav.subNavs || !nav.subNavs.length ? false :
                    <ul className="subnav">
                        {nav.subNavs.map((subNav, subNavIndex) => {
                            return (
                                <li key={nav.id + "-" + subNavIndex}>
                                    <Link to={subNav.link.toLowerCase()} onClick={() => handleSublinkClick(nav.id, subNav.link)} className={flex.replaceAll(subNav.id, ".", "-").toLowerCase()}>{subNav.summary}</Link>
                                </li>);
                        })}
                    </ul>;
                return (
                    <li className="main-li" key={"topnav-" + nav.id}>
                        <Link to={nav.link} className={navItemClass} onClick={() => handleNavItemclick(nav.id, nav.link)}>
                            <span className={`nav-item-value${navItemActiveClass}`}>{nav.summary}</span>
                        </Link>{subNavs}
                    </li>);
            });

            return (
                <nav className={"nav primary-nav xs-append-body print-hidden " + navClass} data-xs-sheet="main-nav">
                    {result}
                    <a className="close xs-visible" onClick={this.props.toggleMobileNav} data-sheet-toggle="main-nav">
                        <span className="visually-hidden">Close Menu</span>
                    </a>
                    <ul className="nav-list">
                        <UserSummary appContext={appContext} session={session} />{navs}
                        { helpUrl && 
                            <li className="main-li xs-visible">
                                <a href="/help" target="_blank">Help</a>
                            </li>
                        }
                        <li className="main-li xs-visible">
                            <Link to={logoutUrl}>Logout</Link>
                        </li>
                    </ul>
                    <div className="hdr-bottom-container">
                        <div className="hdr-bottom-container-img-1"></div>
                        <div className="hdr-bottom-container-img-2"></div>
                    </div>
                </nav>
            );
        }
    }

    class UserSummary extends React.Component {
        static contextType = RouterContext;
        static defaultProps = {
            session: false
        };

        state = {
            orgChanging: false,
            typeaheadValue: ''
        };

        componentDidMount = () => {
            if (this.renderPredictiveDealerSearch()) {
                const currentOrgSummary = this.getCurrentOrgSummary();

                this.setState({ typeaheadValue: currentOrgSummary });
            }
        };

        renderPredictiveDealerSearch = () => flex.claim(CLAIMS.PREDICTIVE_DEALER_SEARCH);

        handleUserOrgChange = (e) => {
            const userOrgId = e.target.value;
            this.setState({
                orgChanging: true
            });
            flex.trigger("global:session-change-user-org", { userOrgId: userOrgId });
        };

        handleTypeaheadChange = value => {
            this.setState({ typeaheadValue: value });
        };

        handleTypeaheadBlur = () => {
            const currentOrgSummary = this.getCurrentOrgSummary();

            this.setState({ typeaheadValue: currentOrgSummary });
        };

        handleTypeaheadMatchSelect = match => {
            this.handleUserOrgChange({ target: { value: match.key }});
        };

        getCurrentOrgSummary = () => {
            const { appContext = {} } = this.props;
            const { userContext = {} } = appContext;
            const currentUserOrgId = userContext.currentContext && appContext.userContext.currentContext.userOrg && appContext.userContext.currentContext.userOrg.id;
            const currentOrgs = userContext.allUserOrgsForApp && appContext.userContext.allUserOrgsForApp.filter(org => org.id === currentUserOrgId);
            const currentOrgSummary = currentOrgs && currentOrgs[0] && currentOrgs[0].summary;

            return currentOrgSummary;
        }

        render() {
            const appContext = this.props.appContext;
            const session = this.props.session;
            const state = this.state || {};
            const { orgChanging, typeaheadValue } = state;

            const helpUrl = appContext.app ? appContext.app.helpUrl : false;

            if (!session || !session.user) { return false; }

            const { Link } = this.context;
            const logoutUrl = getLogoutUrl(flex);
            const logoutLink = <span className="logoutWrapper"><Link to={logoutUrl} className="logout-link">Logout</Link></span>;
            const currentUserOrgId = (!appContext || !appContext.userContext || !appContext.userContext.currentContext || !appContext.userContext.currentContext.userOrg)
                ? false : appContext.userContext.currentContext.userOrg.id;
            let userOrgSelect;

            if (this.renderPredictiveDealerSearch()) {
                userOrgSelect = (
                    <Typeahead
                        options={appContext.userContext.allUserOrgsForApp.map(org => ({ key: org.id, displayValue: org.summary }))}
                        value={typeaheadValue}
                        onInputChange={this.handleTypeaheadChange}
                        onInputBlur={this.handleTypeaheadBlur}
                        onMatchSelect={this.handleTypeaheadMatchSelect}
                        typeaheadClassName="typeahead user-org-typeahead"
                        inputProps={{ className: 'user-org-select' }}
                    />
                );
            } else {
                userOrgSelect = (!currentUserOrgId || !appContext || !appContext.userContext || !appContext.userContext.allUserOrgsForApp) ? false :
                (
                    <select onChange={this.handleUserOrgChange} disabled={orgChanging} defaultValue={currentUserOrgId} style={{ backgroundImage: "none" }}>
                        {_.map(_.sortBy(appContext.userContext.allUserOrgsForApp, [org => org.summary.toLowerCase()]), (userOrg, index) => {
                            var blocked = false;
                            var dealerIssues = session.dealerIssues[userOrg.id];
                            for (var i = 0; i < dealerIssues.length; i++) {
                                if (dealerIssues[i].personIssueAffectsAllDealerships == "Block") {
                                    blocked = true;
                                }
                            }
                            var optionStyle = blocked ? { color: "red" } : {};
                            return (
                                <option key={index} value={userOrg.id} style={optionStyle} disabled={blocked}>{userOrg.summary}</option>
                            );
                        })}
                    </select>
                );
            }


            const userOrgSelectComponent = userOrgSelect;
            return (
                <li className="user-block user">
                    <span className="user-info user-info-summary">
                        {logoutLink}<span className="user-summary">{session.user.summary}</span>
                    </span>
                    <div className="form-group dealership">
                        {userOrgSelectComponent}
                    </div>
                    { helpUrl && <span className="user-info user-help-link"><span className="logoutWrapper helpWrapper"><a className="help-link logout-link" href="/help" target="_blank">Help</a></span></span> }
                </li>
            );
        }
    }

    class Header extends React.Component {
        static contextType = RouterContext;
        static defaultProps = {
            session: false,
            appContext: false
        };

        constructor(props) {
            super(props);
            const navigatedToLink = sessionStorage.getItem('navigatedToLink');
            const topNav = props.topNav || navigatedToLink === window.location.pathname && sessionStorage.getItem('navigatedFrom');

            this.state = {
                mobileNavVisible: false,
                topNav
            };

            sessionStorage.removeItem('navigatedFrom');
            sessionStorage.removeItem('navigatedToLink');
        }

        toggleMobileNav = () => {
            this.setState({ mobileNavVisible: !this.state.mobileNavVisible })
            document.querySelector("html").classList.toggle("nav-menu-open");
        };

        handleSublinkClick = (topNav, link) => {
            sessionStorage.setItem("navigatedFrom", topNav);
            sessionStorage.setItem("navigatedToLink", link);
            this.setState({
                mobileNavVisible: !this.state.mobileNavVisible,
                topNav
            });
        }

        handleNavItemclick = (topNav, link) => {
            sessionStorage.setItem("navigatedFrom", topNav);
            sessionStorage.setItem("navigatedToLink", link);
            this.setState({ topNav });
        }

        findTopNav = (url) => {
            const { appContext } = this.props;
            const tempNav = appContext.nav || {};
            const tempNavs = tempNav.navs || [];
            const uppercasedURL = url.toUpperCase();
            const topNavItems = tempNavs.map(function (nav) {
                if (nav.link.toUpperCase() === uppercasedURL) {
                    return [nav];
                }

                return nav.subNavs.filter(subNav => subNav.link.toUpperCase() === uppercasedURL).map(subNav => ({ ...subNav, id: nav.id }));
            }).filter(arr => arr.length !== 0);
            const filteredNavItems = _.concat(...topNavItems);

            if (filteredNavItems.length > 1) {
                const primaryLink = filteredNavItems.find(i => i.isPrimary);
                if (primaryLink) {
                    return primaryLink.id
                }

                return filteredNavItems[0].id;
            }
            else if (filteredNavItems.length === 1) {
                return filteredNavItems[0].id;
            }

            return '';
        }

        clearSessionStorage = () => {
            sessionStorage.removeItem("navigatedFrom");
            sessionStorage.removeItem("navigatedToLink");
        }

        render() {
            this.clearSessionStorage();
            const { appContext, session } = this.props;
            const сlaims = appContext.claims;
            const { Link } = this.context;
            const claimsubMenu = flex.claim("per.Home.CanAccessSubMenu", сlaims);
            const topNav = this.state.topNav || this.findTopNav(window.location.pathname);
            const subMenu = claimsubMenu && <MainSubNav appContext={appContext} session={session} topNav={topNav}></MainSubNav>;
            const mobileNavVisible = this.state.mobileNavVisible || false;
            const mobileActive = mobileNavVisible ? "active" : "";

            if (session && session.isMobile) {
                return false;
            }
            if (!session || !appContext) {
                return <div>
                    <header id="top" className="page-header" role="banner">
                        <div className="container container-fluid top-container">
                            <a href="#" className="logo"></a>
                        </div>
                    </header>
                </div>;
            }
            return (
                <div className="main-nav-container">
                    <div id="main-nav-toggle" className="header-info mobile-nav xs-visible print-hidden" onClick={this.toggleMobileNav}>
                        <a className="main-menu-toggle" data-sheet-toggle="main-nav" title="Main Menu">
                            <span className="fa fa-bars" aria-hidden="true"></span>
                        </a>
                    </div>
                    <header id="top" className="page-header hidden-print" role="banner">
                        <div className="container container-fluid top-container no-print">
                            <Link to="/" className="logo"></Link>
                            <div className="header-info xs-hidden">
                                <span className="company-info">{flex.text('UX_HEADER_COMPANY_INFO')}</span>
                            </div>
                            <NavTop visible="true" appContext={appContext} topNav={topNav} session={session} handleSublinkClick={this.handleSublinkClick} handleNavItemclick={this.handleNavItemclick} />
                        </div>
                        <nav className="main-subnav xs-hidden print-hidden">
                            {subMenu}
                        </nav>
                    </header>
                    <NavTop visible={mobileNavVisible} appContext={appContext} topNav={topNav} session={session} toggleMobileNav={this.toggleMobileNav} navClass={"xs-visible " + mobileActive} handleSublinkClick={this.handleSublinkClick} />
                </div>
            );
        }
    }

    return Header;
};

module.exports = initComponent;
